import Subscription from './Subscription';
import SubscriptionValidity from './SubscriptionValidity';

export interface RawSubscription {
	systemModules: string[];
	validity: { since: string; until: string };
	deactivatedTime: string | null;
}

export default function mapSubscription(subscription: RawSubscription): Subscription {
	return new Subscription(
		new Set(subscription.systemModules),
		new SubscriptionValidity(new Date(subscription.validity.since), new Date(subscription.validity.until)),
		subscription.deactivatedTime !== null ? new Date(subscription.deactivatedTime) : null
	);
}
